import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { addAdIncome, updAdIncome } from "@/api/financial/consumptionDetails";
import { serchSelect, serchSelectManage } from "@/mixins/index";
export default {
  mixins: [serchSelect, serchSelectManage],
  data: function data() {
    var _this = this;

    var validateNum = function validateNum(rule, value, callback) {
      if (value === '') {
        callback(new Error(_this.$t('pleaseInputAdIncome')));
      } else {
        if (!/^[1-9]\d*$/.test(value)) {
          callback(new Error(_this.$t('cannotInputZeroOrDecimal')));
        }

        callback();
      }
    };

    return {
      pickerOptions0: {
        //限制时间不能超过此时
        disabledDate: function disabledDate(time) {
          if (_this.searchData.date != "") {
            return time.getTime() > Date.now() || time.getTime() > _this.searchData.date;
          } else {
            return time.getTime() > Date.now();
          }
        }
      },
      dialogFormVisible: false,
      searchData: {
        special_product_id: "",
        id: "",
        game: "",
        platform: "",
        channel: "",
        pkg: "",
        ad_channel: '',
        ad_placement: '',
        country: '',
        date: "",
        ad_income: ""
      },
      isDisplay: false,
      rules: {
        special_product_id: [{
          required: true,
          message: this.$t('selectProduct'),
          trigger: "blur"
        }],
        game: [{
          required: true,
          message: this.$t('pleaseSelectGame'),
          trigger: "blur"
        }],
        platform: [{
          required: true,
          message: this.$t('pleaseSelectPlatform'),
          trigger: "blur"
        }],
        channel: [{
          required: true,
          message: this.$t('pleaseSelectChannel'),
          trigger: "blur"
        }],
        pkg: [{
          required: true,
          message: this.$t('pleaseSelectPackageName'),
          trigger: "blur"
        }],
        date: [{
          required: true,
          message: this.$t('selectDate'),
          trigger: "blur"
        }],
        // country: [{ required: true, message: "请选择国家", trigger: "blur" }],
        ad_income: [{
          required: true,
          validator: validateNum,
          trigger: "blur"
        }]
      },
      adPlacementSingleChoice: true,
      issubstitution: false
    };
  },
  created: function created() {},
  methods: {
    open: function open(data) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var ProductData, ds, k;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.dialogFormVisible = true;
                _this2.isDisplay = data ? true : false;

                if (!data) {
                  _context.next = 15;
                  break;
                }

                _context.next = 5;
                return _this2.searchProductData(data);

              case 5:
                ProductData = _context.sent;
                data.product_id = ProductData.id;
                _context.next = 9;
                return _this2.getAdvPlarform({
                  special_product_id: data.product_id
                });

              case 9:
                _this2.searchData.ad_channel = data.ad_channel;
                _context.next = 12;
                return _this2.advChannelchange(data.ad_channel);

              case 12:
                ds = {};

                for (k in _this2.searchData) {
                  ds[k] = data[k] ? data[k] : '';
                }

                _this2.searchData = _this2.processingData(_objectSpread(_objectSpread({}, ds), {}, {
                  special_product_id: data.product_id
                }));

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    resetForm: function resetForm(formName) {
      this.dialogFormVisible = false;
      this.searchData.id = '';
      this.clearData();
    },
    dataFormSubmit: function dataFormSubmit(formName) {
      var _this3 = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          var req = _this3.searchData.id ? updAdIncome : addAdIncome;
          var searchData = JSON.parse(JSON.stringify(_this3.searchData));
          req(searchData).then(function (res) {
            if (res.status == 200) {
              _this3.$Message.success(_this3.$t('operationSuccess'));

              _this3.$emit("refreshDataList");

              _this3.resetForm("ruleForm");
            }
          });
        }
      });
    },
    clearData: function clearData() {
      this.searchData = {
        id: this.searchData.id,
        game: "",
        platform: "",
        channel: "",
        pkg: "",
        ad_channel: '',
        ad_placement: '',
        country: '',
        date: "",
        ad_income: "",
        special_product_id: this.rawData.game_show_type == 1 ? '' : this.searchData.special_product_id
      };

      if (this.rawData.game_show_type == 1) {
        this.advchannels = [];
      }

      this.advLocation = [];
      this.$refs.ruleForm.resetFields();
    }
  }
};